<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="addlock"
      >
        新增锁定
      </el-button>
      <el-button
        class="filter-item"
        type="primary"
        size="small"
        @click="showaddLog = true"
      >
        批量导入
      </el-button>
      <el-input
        size="small"
        v-model="listQuery.user_id"
        placeholder="请输入 UserID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        size="small"
        v-model="listQuery.status"
        placeholder="是否已绑定用户"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="是" value="lock" />
        <el-option label="否" value="unlock" />
      </el-select>
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="UserID锁定">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="分配指定用户">
        <template slot-scope="scope">
          {{ scope.row.user?.uuid || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="绑定前id">
        <template slot-scope="scope">
          {{ scope.row.change_log?.user_before_uuid || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="是否已绑定用户">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'lock'" type="success">是</el-tag>
          <el-tag v-else-if="scope.row.status === 'unlock'" type="warning"
            >否
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
            v-if="scope.row.status === 'unlock'"
          >
            修改
          </el-button>
          <el-button
            type="info"
            size="mini"
            @click="unlock(scope.row)"
            v-if="scope.row.status === 'lock'"
          >
            解绑
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="Delete(scope.row)"
            v-else-if="scope.row.status === 'unlock'"
          >
            释放
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="批量导入"
      :visible.sync="showaddLog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form ref="addLogform" :model="addLogform" label-width="0px">
        <el-row type="flex">
          <el-col :span="8">
            <el-upload
              class="filter-item"
              accept=".xlsx,.xls"
              action=""
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleImportUsers"
            >
              <el-button type="warning" icon="el-icon-upload" size="small">
                一键导入
              </el-button>
            </el-upload>
          </el-col>
          <el-button
            class="filter-item"
            type="primary"
            @click="downloadExcel"
            size="small"
          >
            Excel 模板下载
          </el-button>
        </el-row>
        <div style="height: 500px" class="scrollbar">
          <el-scrollbar style="height: 500px">
            <el-table :data="addLogform.uuidLockBatch" style="width: 1100px">
              <el-table-column label="UserID锁定" min-width="60" align="center">
                <template slot-scope="scope">
                  {{ scope.row.uuid || '' }}
                </template>
              </el-table-column>
              <el-table-column
                label="分配指定用户"
                min-width="60"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.user_id || '' }}
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
        <el-row type="flex" justify="end">
          <el-button @click="showaddLog = false">取消</el-button>
          <el-button type="primary" @click="postaddLog">确认</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { excel2Json } from '@/utils/excel'
export default {
  data() {
    return {
      showaddLog: false,
      addLogform: {
        uuidLockBatch: [],
      },
      btnLoading: false,
      isall: false,
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        status: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    showaddLog(val) {
      if (!val) {
        this.addLogform.uuidLockBatch = []
      }
    },
  },
  methods: {
    postaddLog() {
      if (this.addLogform.uuidLockBatch.length == 0) {
        this.$message.error('请先导入数据')
        return
      }
      return request({
        url: '/api/backend/uuidLock/addBatch',
        method: 'POST',
        data: { data: this.addLogform.uuidLockBatch },
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功',
            })
            this.addLogform.uuidLockBatch = []
            this.showaddLog = false
            this.getList()
          }
        })
        .finally((val) => {
          console.log(val)
        })
    },
    handleImportUsers(file) {
      this.addLogform.uuidLockBatch = []
      file = file.raw
      if (
        !(file.name.split('.')[1] == 'xlsx' || file.name.split('.')[1] == 'xls')
      ) {
        this.$message.error('上传文件格式不正确，请检查选择的文件')
        return
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData)
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error('数据不能为空')
          return
        }
        excelData.forEach((element, index) => {
          if (element['UserID锁定']) {
            this.addLogform.uuidLockBatch.push({
              uuid: element['UserID锁定'],
              user_id: element['分配指定用户'],
            })
          }
          console.log(element, '--------', index)
        })
      })
    },
    downloadExcel() {
      let a = document.createElement('a')
      a.href = '/Userid锁定模板.xlsx'
      a.download = 'Userid锁定模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    Delete(row) {
      this.$confirm('是否确认释放？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/uuidLock/delete',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((response) => {
            this.$message.success('释放成功')
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    unlock(row) {
      this.$confirm('是否确认解绑？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/uuidLock/unlock',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((response) => {
            this.$message.success('解绑成功')
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    addlock() {
      this.$router.push('/USER/useridlockEdit')
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/uuidLock/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(row) {
      this.$router.push('/USER/useridlockEdit?id=' + row.id)
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
